import { combineReducers } from 'redux'
import { createReducer } from 'helpers/ReducerUtil'
import {
  UPDATE_NAME,
  UPDATE_ACTIVE,
  UPDATE_FILE_ID,
} from './constants'

const updateFileId = (prev, { id }) => id
const updateActive = (prev, { active }) => active
const updateName = (prev, { value }) => value
const resetActive = () => false
const resetFileId = () => null
const resetName = () => ''

const activeReducer = createReducer(resetActive(), {
  [UPDATE_ACTIVE]: updateActive,
})

const fileIdReducer = createReducer(resetFileId(), {
  [UPDATE_FILE_ID]: updateFileId,
})

const nameReducer = createReducer(resetName(), {
  [UPDATE_NAME]: updateName,
})

export default combineReducers({
  active: activeReducer,
  id: fileIdReducer,
  name: nameReducer
})
